import React from 'react';

import {
  connect
} from 'react-redux';
import {
  actionCreators
} from './store';


import Header from 'component/mobile_header'
import Catalog from './components/catalog'

class LabRoom extends React.Component{
    constructor(props){
        super(props);
        this.state={
            title:'实验室'
        }
    }
  async componentWillMount(){
    const {getCourseInfo, getFinishedCourse, user_id, info} =this.props;
    await getCourseInfo(this.props.match.params.id)
    // console.log(localStorage.getItem('courseid'), this.props.match.params.id, 'id')
    // getCourseInfo(JSON.parse(localStorage.getItem('courseid')))
    // 获取已完成课程列表
    let get_user_id = JSON.parse(localStorage.getItem('userinfo')).user_id;
    getFinishedCourse(this.props.match.params.id, user_id.length? user_id: get_user_id);
  }

  render(){
    const {subject,id,title,finishdedList, timeInfo, info}=this.props;
    console.log(info, 'labroomIndexInfo')
    return (
      <div>
        <Header title = { title }/>
        <div className="container">
          <Catalog data={subject} id={id} finish={finishdedList}/>
        </div>
      </div>

      )
  }
}

const mapState = (state) => ({
    subject: state.getIn(['labroom', 'subject']),
    id: state.getIn(['labroom', 'courseid']),
    title: state.getIn(['labroom', 'title']),
    user_id: state.getIn(['home','userinfo', 'user_id']),
    finishdedList: state.getIn(['labroom', 'finishedList'])
})

const mapDispatch = (dispatch) => ({
    getCourseInfo(course_id) {
        dispatch(actionCreators.getCourseInfo(course_id))
    },
    getFinishedCourse(course_id, user_id){
      dispatch(actionCreators.getFinishedCourse(course_id, user_id))
    }
})
export default connect(mapState, mapDispatch)(LabRoom);
